var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilLoggedinActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "util-loggedin-active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--color-text-primary);}\n\t.st1{fill:#A0E73F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,23.6c-2.8-0.9-4.6-2.1-3.2-4.9c6.3-11.9,1.7-18.2-5-18.2c-6.8,0-11.3,6.6-5,18.2c2.1,3.9-2.3,4.8-6.8,5.9 c-4.6,1.1-4.2,3.5-4.2,7.8h21c0-0.4-0.1-0.8-0.1-1.2C21.3,28.2,22.5,25.5,24.5,23.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_",
    className: "st1",
    d: "M23.7,30.5c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S23.7,34.9,23.7,30.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilLoggedinActive);
export default __webpack_public_path__ + "static/media/util-loggedin-active.1e1152bcc1f551417cfa7de579c7cbf4.svg";
export { ForwardRef as ReactComponent };